import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { UPLOAD_SOURCES } from '@cld/upload-widget-common';
import t from 'common/i18n';
import { authorLink, LICENSE_TYPE_LINK } from '../../data/consts';

const SectionBox = styled.section`
  padding: ${globalTheme.spacing.md};
  > label {
    font-weight: bold;
    white-space: nowrap;
    display: block;
    padding-bottom: ${globalTheme.spacing.xs};
    font-size: ${globalTheme.font.size.xs};
  }
`;

const SectionLine = styled.div`
  display: flex;
  padding-bottom: ${globalTheme.spacing.sm};
  label {
    display: block;
    width: 100px;
  }
  span {
    color: ${globalTheme.palette.secondary};
    width: 210px;
  }
  a {
    text-decoration: underline;
  }
`;

const { GETTY, ISTOCK } = UPLOAD_SOURCES;

export default ({ selectedAsset, selectedProduct, source }) => {
  return (
    <SectionBox>
      {source === ISTOCK && selectedProduct?.type === 'creditpack' && (
        <SectionLine>
          <label>{t(`${source}.purchase.cost`)}</label>
          <span>
            {selectedAsset.creditPrice} {t(`${source}.purchase.credit${selectedAsset.creditPrice > 1 ? 's' : ''}`)}
          </span>
        </SectionLine>
      )}
      {source === GETTY && (
        <SectionLine>
          <label>{t(`${source}.purchase.credit`)}</label>
          <span>
            <a href={authorLink(selectedAsset.assetFamily, selectedAsset.artist)} rel="noopener noreferrer" target="_blank">
              {selectedAsset.artist}
            </a>
          </span>
        </SectionLine>
      )}
      {source === ISTOCK && (
        <SectionLine>
          <label>{t(`${source}.purchase.credit`)}</label>
          <span>{selectedAsset.artist}</span>
        </SectionLine>
      )}
      {source === GETTY && (
        <SectionLine>
          <label>{t(`${source}.purchase.item_id`)}</label>
          <span>{selectedAsset.id}</span>
        </SectionLine>
      )}
      {source === GETTY && (
        <SectionLine>
          <label>{t(`${source}.purchase.license_type`)}</label>
          <span>
            <a href={LICENSE_TYPE_LINK} rel="noopener noreferrer" target="_blank">
              {t(`${source}.purchase.${selectedAsset.licenseModel}`)}
            </a>
          </span>
        </SectionLine>
      )}
      <SectionLine>
        <label>{t(`${source}.purchase.collection`)}</label>
        <span>{selectedAsset.collectionCode}</span>
      </SectionLine>
      {selectedAsset.country && (
        <SectionLine>
          <label>{t(`${source}.purchase.location`)}</label>
          <span>
            {selectedAsset.country}
            {selectedAsset.city ? `, ${selectedAsset.city}` : ''}
          </span>
        </SectionLine>
      )}
      {source === ISTOCK && (
        <SectionLine>
          {selectedAsset.isVideo && <label>{t(`${source}.purchase.${source}_video_id`)}</label>}
          {!selectedAsset.isVideo && <label>{t(`${source}.purchase.${source}_photo_id`)}</label>}
          <span>{selectedAsset.id}</span>
        </SectionLine>
      )}

      {selectedAsset.releaseInfo && (
        <SectionLine>
          <label>{t(`${source}.purchase.release_info`)}</label>
          <span>{selectedAsset.releaseInfo}</span>
        </SectionLine>
      )}
      {source === GETTY && selectedAsset.title && (
        <SectionLine>
          <label>{t(`${source}.purchase.description`)}</label>
          <span>{selectedAsset.title}</span>
        </SectionLine>
      )}
    </SectionBox>
  );
};
